import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { Limit } from "../domain/limit";
import { Test } from "../domain/test";
import { CoreData } from "../tools/core-data/core-data";
import { mapper } from "../tools/mapping/mapper";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { TestDTO } from "./dto/test.dto";
import { AppConfig } from "../app.config";

@Injectable({
    providedIn: 'root',
})
export class LimitService extends BaseService {

    private serviceUrl = `${this.config.getConfig('serviceBaseUrl')}api/limit`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected override snackBar: MatSnackBar,
        protected override oauthService: OAuthService,
        private loadingTask: LoadingTask,
        protected override router: Router,
        private config: AppConfig) {
        super(router, coreData, oauthService, snackBar);
    }

    getLimitListByTest(testCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/byTest/${testCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getLimitListByTest')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: TestDTO[]) => {
                return response.map((item: TestDTO) => {
                    return mapper.map(item, TestDTO, Test);
                });
            }));
    }

    create(l: Limit, testCode: string) {

        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/${testCode}`, l, this.generateHeader()).pipe(
            catchError(this.handleError<any>('create')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    update(l: Limit) {

        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}`, l, this.generateHeader()).pipe(
            catchError(this.handleError<any>('update')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    delete(limitCode: string) {

        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${limitCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('delete')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }
}